import ChatMessage from "@mapmycustomers/shared/types/chat/ChatMessage";
import ChatSuggestion from "@mapmycustomers/shared/types/chat/ChatSuggestion";

import { ChatThreadKey } from "@app/util/chat/getChatThreadKey";
import { ChatProposalUiState } from "@app/util/chat/proposalRowStatus";

// One record's conversation, keyed by getChatThreadKey.
export interface ChatThreadState {
  // Undefined until the first turn comes back. Echoed on every later turn to continue the
  // same server-side conversation.
  conversationId?: number;
  messages: readonly ChatMessage[];
  // The current turn's chips only, replaced every turn and never persisted.
  suggestions: readonly ChatSuggestion[];
}

// One shared reference: selectors hand it back for an absent thread, and a fresh object each time
// would churn every consumer. Frozen because that sharing is also its risk — an in-place sort on a
// selector result would otherwise reach every thread-less pane at once, quietly.
export const emptyChatThread: ChatThreadState = Object.freeze({
  messages: Object.freeze([]),
  suggestions: Object.freeze([]),
});

export default interface ChatConversationState {
  byThread: Partial<Record<ChatThreadKey, ChatThreadState>>;
  // Apply-call state per proposals message: "inFlight" disables the card, "failed" shows the
  // card-level error line. Never persisted — a reload lands back on actionable.
  proposalApply: Record<string, "failed" | "inFlight">;
  // Rep-side proposal state (checked/draft) plus folded apply outcomes, keyed by proposalId.
  // Lives beside the threads so the transcript stays exactly what arrived on the wire, and flat
  // rather than per thread because server-minted proposal ids cannot collide between threads.
  proposalUi: Record<number, ChatProposalUiState>;
}
